import type { TemplateOnlyComponent } from '@ember/component/template-only';

export interface Signature {
  Args: {
    class?: string;
  };
  Element: SVGElement;
}

const WrStetoscopeIconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    class={{@class}}
    ...attributes
  >
    <path
      d='M1.30078 0.999805C1.30078 0.613205 1.61418 0.299805 2.00078 0.299805H4.50078C4.88738 0.299805 5.20078 0.613205 5.20078 0.999805C5.20078 1.3864 4.88738 1.6998 4.50078 1.6998H2.70078V4.9998C2.70078 6.82234 4.17824 8.2998 6.00078 8.2998C7.82332 8.2998 9.30078 6.82234 9.30078 4.9998V1.6998H7.50078C7.11418 1.6998 6.80078 1.3864 6.80078 0.999805C6.80078 0.613205 7.11418 0.299805 7.50078 0.299805H10.0008C10.3874 0.299805 10.7008 0.613205 10.7008 0.999805V4.9998C10.7008 7.35753 8.96472 9.30978 6.70117 9.64797V11.4998C6.70117 13.0462 7.95477 14.2998 9.50117 14.2998H10.0012C11.0685 14.2998 11.9661 13.5727 12.2256 12.5869C11.1122 12.2537 10.3008 11.2215 10.3008 9.9998C10.3008 8.50864 11.5096 7.2998 13.0008 7.2998C14.492 7.2998 15.7008 8.50864 15.7008 9.9998C15.7008 11.2675 14.8272 12.3311 13.6492 12.6214C13.3535 14.3689 11.8328 15.6998 10.0012 15.6998H9.50117C7.18158 15.6998 5.30117 13.8194 5.30117 11.4998V9.64809C3.03724 9.31023 1.30078 7.3578 1.30078 4.9998V0.999805ZM11.7008 9.9998C11.7008 10.7178 12.2828 11.2998 13.0008 11.2998C13.7188 11.2998 14.3008 10.7178 14.3008 9.9998C14.3008 9.28183 13.7188 8.6998 13.0008 8.6998C12.2828 8.6998 11.7008 9.28183 11.7008 9.9998Z'
      fill='currentColor'
    />
  </svg>
</template>;

export default WrStetoscopeIconComponent;
